import React, { useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { createPurchase } from "../../api";
import "./CreatePurchase.css";

const CreatePurchase = () => {
  const { customerId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [purchase, setPurchase] = useState({
    invoiceNo: "",
    date: "",
    amount: "",
    productSku: "",
    headSize: "98",
    unstrungWeight: "305",
    length: "27",
    stringingPattern: "16x20",
    grip: "Grip 3",
  });

  const [successMessage, setSuccessMessage] = useState(
    location.state?.successMessage || "" 
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPurchase({ ...purchase, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await createPurchase({
        ...purchase,
        customerId,
      });
      setSuccessMessage(
        "Purchase and product details have been added successfully."
      );
      setPurchase({
        invoiceNo: "",
        date: "",
        amount: "",
        productSku: "",
        headSize: "98",
        unstrungWeight: "305",
        length: "27",
        stringingPattern: "16x20",
        grip: "Grip 3",
      });
    } catch (error) {
      console.error(
        "Error creating purchase:",
        error.response ? error.response.data : error.message
      );
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="create-purchase-container">
      <form onSubmit={handleSubmit} className="create-purchase-form">
        <h2>Add Purchase</h2>
        {successMessage && <p className="success-message">{successMessage}</p>}

        {/* Row 1: Invoice No and Date */}
        <div className="form-row">
          <div className="form-group">
            <label>Invoice No:</label>
            <input
              type="text"
              name="invoiceNo"
              value={purchase.invoiceNo}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Date:</label>
            <input
              type="date"
              name="date"
              value={purchase.date}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        {/* Row 2: Amount and Product SKU */}
        <div className="form-row">
          <div className="form-group">
            <label>Amount:</label>
            <input
              type="number"
              name="amount"
              value={purchase.amount}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Product SKU:</label>
            <input
              type="text"
              name="productSku"
              value={purchase.productSku}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        {/* Row 3: Head Size and Unstrung Weight */}
        <div className="form-row">
          <div className="form-group">
            <label>Head Size:</label>
            <select
              name="headSize"
              value={purchase.headSize}
              onChange={handleChange}
            >
              <option value="98">98</option>
              <option value="100">100</option>
              <option value="105">105</option>
            </select>
          </div>
          <div className="form-group">
            <label>Unstrung Weight:</label>
            <select
              name="unstrungWeight"
              value={purchase.unstrungWeight}
              onChange={handleChange}
            >
              <option value="295">295</option>
              <option value="305">305</option>
              <option value="315">315</option>
            </select>
          </div>
        </div>

        {/* Row 4: Length and Stringing Pattern */}
        <div className="form-row">
          <div className="form-group">
            <label>Length:</label>
            <select
              name="length"
              value={purchase.length}
              onChange={handleChange}
            >
              <option value="27">27</option>
              <option value="27.5">27.5</option>
              <option value="28">28</option>
            </select>
          </div>
          <div className="form-group">
            <label>Stringing Pattern:</label>
            <select
              name="stringingPattern"
              value={purchase.stringingPattern}
              onChange={handleChange}
            >
              <option value="16x19">16x19</option>
              <option value="16x20">16x20</option>
              <option value="18x20">18x20</option>
            </select>
          </div>
        </div>

        {/* Row 5: Grip */}
        <div className="form-row">
          <div className="form-group">
            <label>Grip:</label>
            <select name="grip" value={purchase.grip} onChange={handleChange}>
              <option value="Grip 1">Grip 1</option>
              <option value="Grip 2">Grip 2</option>
              <option value="Grip 3">Grip 3</option>
            </select>
          </div>
        </div>

        <button type="submit" className="submit-button">
          Add Purchase
        </button>
        <button type="button" className="back-button" onClick={handleBack}>
          Back
        </button>
      </form>
    </div>
  );
};

export default CreatePurchase;



